import { createContext, useContext } from 'react'

import { CoreApi } from 'src/apis/core'
import { fetchCoreApi } from 'src/apis/core/fetch'


export const CoreApiContext = createContext<CoreApi>(fetchCoreApi({ baseUrl: 'localhost:9000' }))

export const useCoreApi = () => useContext(CoreApiContext)
